import classNames from "classnames";
import styles from "./CardList.module.scss";
import { GlobalCardBlock } from "SiteComponents";
import { GlobalCardBlockProps } from "components/blocks/GlobalCardBlock/GlobalCardBlock";

export interface CardListProps {
  listItems: GlobalCardBlockProps[];
  type?:
    | "PublicationPage"
    | "InfoPage"
    | "EventPage"
    | "TilskuddPage"
    | "GenericPage"
    | "ReportReadPage";
  theme?: "bold" | "moderate" | "outlined" | "soft" | "vivid" | "flatImageWithTitle";
  isInsideTabs?: boolean;
}

const CardList: React.FC<CardListProps> = ({
  listItems,
  type,
  theme,
  isInsideTabs,
}) => {
  const isMedium =
  (type === "TilskuddPage" ||
    type === "GenericPage" ||
    type === "ReportReadPage") &&
  theme !== "flatImageWithTitle";
  return (
    <>
      {listItems.length > 0 && (
        <ul
          className={classNames(styles.cardList, {
            [styles.isMedium]: isMedium,
            [styles.isInsideTabs]: isInsideTabs,
            [styles.fullWidth]: type === "ReportReadPage" && theme !== "flatImageWithTitle",
          })}
        >
          {listItems.map(
            (card, index) =>
              card?.link?.url && (
                <li key={index}>
                  <GlobalCardBlock
                    isMedium={isMedium}
                    theme={theme}
                    type={type}
                    {...card}
                  />
                </li>
              )
          )}
        </ul>
      )}
    </>
  );
};

export default CardList;
